// extracted by mini-css-extract-plugin
export default {"storeCard":"style-module--storeCard---AY5C","gridCenter":"style-module--gridCenter--CuxXf"};